import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSuspendedSubscriptionSettingParams {
  user: string;
}

export interface IGetSuspendedSubscriptionSettingResult extends IResult {
  enabled: boolean;
}
export class GetSuspendedSubscriptionSettingRequest extends Request<IGetSuspendedSubscriptionSettingParams, IResult> {
  constructor(params: IGetSuspendedSubscriptionSettingParams) {
    super('getSuspendedSubscriptionNotificationSetting', params);
  }
}
